import createSigninWithEmailDeepLink from '@th/frontend-shared/src/helpers/auth/createSigninWithEmailDeepLink';
import createInviteActionCodeSettings from '@th/frontend-shared/src/helpers/auth/createInviteActionCodeSettings';
import { auth } from '../../utils/firebase';
import { sendSignInLinkToEmail as firebaseSendSignInLinkToEmail } from 'firebase/auth';

export default async function sendSignInLinkToEmail(
  email: string,
  agentSlug?: string,
) {
  const deepLink = createSigninWithEmailDeepLink(email, agentSlug);
  const actionCodeSettings = createInviteActionCodeSettings(deepLink);
  try {
    await firebaseSendSignInLinkToEmail(auth, email, actionCodeSettings);
    window.localStorage.setItem('emailForSignIn', email);
  } catch (err) {
    console.log(err);
  }
}
